<template>
  <SearchLayout :kind="layout">
     <div class="tabs">
      <ul>
        <router-link
          tag="li"
          :to="{ name: 'Search' }"
          icon="fa-align-left"
          active-class="is-active"
          exact
          ><a>Text <b-icon icon="align-left" size="is-small"> </b-icon></a
        ></router-link>
        <!-- <router-link
          tag="li"
          :to="{ name: 'Tags' }"
          icon="fa-tags"
          active-class="is-active"
          exact
          ><a>Tags <b-icon icon="tags" size="is-small"> </b-icon></a></router-link
        > -->
      </ul>
    </div>
    <template #sidebar>
      <SearchSidebar>
	<SearchFacets />
      </SearchSidebar>
    </template>
    <SearchForm style="margin-bottom: 0.75rem"></SearchForm>
    <SearchResult></SearchResult>
  </SearchLayout>
</template>

<script>
 import SearchLayout from '@/components/SearchLayout.vue'
 import SearchSidebar from '@/components/SearchSidebar.vue'
 import SearchFacets from '@/components/SearchFacets.vue'
 import SearchForm from '@/components/SearchForm.vue'
 import SearchResult from '@/components/SearchResult.vue'

 import { createMapper } from '@/utils/mapping.js'

 const mapper = createMapper('browser')

 export default {
   components: {
     SearchLayout,
     SearchSidebar,
     SearchFacets,
     SearchForm,
     SearchResult
   },
   watch: {
     activeTab() {
       this.$router.push({ query: {} });
     }
   },
   data() {
     return {
       activeTab: 0
     }
   },
   computed: {
     layout() {
       const { term } = this.query
       return !term ? 'narrow' : 'sidebar'
     },
     query() {
       return mapper.fromURL(this.$route.query)
     }
   }
 }
</script>
